<template>
    <form-row title="Has Inspection Been Scheduled?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="inspection_has_been_scheduled"
                v-model="inspection_has_been_scheduled"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="inspection_has_been_scheduled"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date of Inspection:"
                :value="inspection.inspection_scheduled_for_date"
                name="inspection_scheduled_for_date"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        inspection: {},
        read_only: { default: false },
    },

    data() {
        return {
            inspection_has_been_scheduled: this.inspection.inspection_has_been_scheduled,
        }
    },
}
</script>
